const USER_ORG_ID_STORAGE_KEY = 'metarouter:sessionOrg';

const SessionStorageService = {
  getSessionOrgInfo: () => {
    const sessionOrgInfo = sessionStorage.getItem(USER_ORG_ID_STORAGE_KEY);
    return sessionOrgInfo ? JSON.parse(sessionOrgInfo) : {};
  },
  getInitialSessionOrgId: () => {
    const { defaultOrgId } = SessionStorageService.getSessionOrgInfo();
    const updatedSessionOrgInfo = JSON.stringify({ defaultOrgId });
    sessionStorage.setItem(USER_ORG_ID_STORAGE_KEY, updatedSessionOrgInfo);
    return defaultOrgId;
  },
  clearSessionOrgInfo: () => {
    sessionStorage.removeItem(USER_ORG_ID_STORAGE_KEY);
  },
  switchOrg: ({ orgId, isOverride = false }) => {
    let { defaultOrgId } = SessionStorageService.getSessionOrgInfo();

    if (!isOverride) {
      defaultOrgId = orgId;
    }

    const sessionOrgInfo = { defaultOrgId };
    sessionStorage.setItem(USER_ORG_ID_STORAGE_KEY, JSON.stringify(sessionOrgInfo));
  },
  setSessionOrgInfo: ({ orgId, isOverride = false }) => {
    if (isOverride) {
      SessionStorageService.setSessionOrgOverrideId(orgId);
    } else {
      SessionStorageService.setSessionOrgId(orgId);
    }
  },
  setSessionOrgId: orgId => {
    const sessionOrgInfo = SessionStorageService.getSessionOrgInfo();
    const updatedSessionOrgInfo = JSON.stringify({ ...sessionOrgInfo, defaultOrgId: orgId, currentOrgId: orgId });
    sessionStorage.setItem(USER_ORG_ID_STORAGE_KEY, updatedSessionOrgInfo);
  },
  setSessionOrgOverrideId: overrideOrgId => {
    const sessionOrgInfo = SessionStorageService.getSessionOrgInfo();
    const updatedSessionOrgInfo = JSON.stringify({ ...sessionOrgInfo, currentOrgId: overrideOrgId });
    sessionStorage.setItem(USER_ORG_ID_STORAGE_KEY, updatedSessionOrgInfo);
  },
};

export default SessionStorageService;
